<template>
  <div>
    <contactForm
      v-if="help"
      @close="help = false"
      :intake="Number($store.state.currentPort)"
      preselectedSubject="Ik wil graag overstappen naar Doelbeleggen.nl"
    />
    <div class="card-content">
      <img src="../../assets/db/DB-logo1.svg" />
      <p class="grey" style="margin: 0">OXBY stapt over naar Doelbeleggen.nl</p>
      <h3>Naast OXBY hebben wij in 2016 prijswinnend Doelbeleggen.nl gelanceerd<br /></h3>
      <img src="../../assets/db/goudenstier.svg" style="width: 60%"/>
      <br /><br />
      <button @click="help = true" style="height: auto;">Stap over</button>
      <p class="grey">
        <a target="_blank" href="https://oxby.nl/vragen/">Lees hier verder over o.a. de voordelen van overstappen naar Doelbeleggen.nl</a>
      </p>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      help: false,
    };
  },
  methods: {
    openDBWebsite() {
      window.open(
        'https://oxby.nl/vragen/',
        '_blank',
      );
    },
  },
};
</script>
<style lang="scss" scoped>
div .card-content {
  text-align: center;
  padding: 10px 20px 0;
}
</style>
